export var orderIsFreeShippingEligible = function orderIsFreeShippingEligible(brandOrder) {
  var selectedBrandOrder = brandOrder.brand_order;
  return (selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.free_shipping) || !!(selectedBrandOrder !== null && selectedBrandOrder !== void 0 && selectedBrandOrder.free_shipping_reason);
};